import type React from "react";
import { CustomToast, ToastProvider as ToastProviderOG } from "@medbillai/ui";
import { ToastViewport, type ToastViewportProps } from "./ToastViewport";
export const ToastProvider = ({
  children,
  ...viewportProps
}: {
  children: React.ReactNode;
} & ToastViewportProps) => {
  return <ToastProviderOG swipeDirection="up" swipeThreshold={20} duration={6000} native={[
    /* uncomment the next line to do native toasts on mobile - note that it won't be as customizable as custom toasts, especially on android */
    // 'mobile'
  ]} data-sentry-element="ToastProviderOG" data-sentry-component="ToastProvider" data-sentry-source-file="ToastProvider.tsx">
      {children}
      <ToastViewport {...viewportProps} data-sentry-element="ToastViewport" data-sentry-source-file="ToastProvider.tsx" />
      <CustomToast data-sentry-element="CustomToast" data-sentry-source-file="ToastProvider.tsx" />
    </ToastProviderOG>;
};